import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { ProductContext } from "@insite/client-framework/Components/ProductContext";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import updateProductInfo from "@insite/client-framework/Store/Components/ProductInfoList/Handlers/UpdateProductInfo";
import { getProductInfoFromList } from "@insite/client-framework/Store/Components/ProductInfoList/ProductInfoListSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import { ProductModel, VariantDisplayTypeValues } from "@insite/client-framework/Types/ApiModels";
import ProductBrand, { ProductBrandStyles } from "@insite/content-library/Components/ProductBrand";

import ProductDescription, { ProductDescriptionStyles } from "@insite/content-library/Components/ProductDescription";
import ProductImage, { ProductImageStyles } from "@insite/content-library/Components/ProductImage";
import ProductPartNumbers, { ProductPartNumbersStyles } from "@insite/content-library/Components/ProductPartNumbers";
import ProductPrice from "@insite/content-library/Components/ProductPrice";
import ProductQuantityBreakPricing, {
    ProductQuantityBreakPricingStyles,
} from "@insite/content-library/Components/ProductQuantityBreakPricing";
import ProductUnitOfMeasureSelect from "@insite/content-library/Components/ProductUnitOfMeasureSelect";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon";
import { SelectPresentationProps } from "@insite/mobius/Select";
import { TypographyPresentationProps } from "@insite/mobius/Typography";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import VisuallyHidden from "@insite/mobius/VisuallyHidden";
import CustomHeartIcon from "@tSurya/Icons/CustomHeartIcon";
import ProductAddToListLink, { ProductAddToListLinkStyles } from "@tSurya/Overrides/Components/ProductAddToListLink";

import ProductListVariantSwatch from "@tSurya/Overrides/Widgets/ProductList/ProductListVariantSwatch";
import { COLORS, TYPOGRAPHY } from "@tSurya/theme/design";
import React, { FC } from "react";
import { connect, ResolveThunks } from "react-redux";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState, ownProps: OwnProps) => ({
    productInfo: getProductInfoFromList(state, ownProps.carouselId, ownProps.product.id),
    isAuthenticated: state.context.session.isAuthenticated,
    pageType: getCurrentPage(state).type,
});

const mapDispatchToProps = {
    updateProductInfo,
};

interface OwnProps {
    carouselId: string;
    product: ProductModel;
    showImage: boolean;
    showBrand: boolean;
    showTitle: boolean;
    showPartNumbers: boolean;
    showPrice: boolean;
    showAddToCart: boolean;
    showAddToList: boolean;
    extendedStyles?: ProductListProductGridCardStyles;
}

type Props = OwnProps & ResolveThunks<typeof mapDispatchToProps> & ReturnType<typeof mapStateToProps>;

export interface ProductListProductGridCardStyles {
    wrapper?: InjectableCss;
    imageWrapper?: InjectableCss;
    sponsoredText?: TypographyPresentationProps;
    productImageStyles?: ProductImageStyles;
    productUnitOfMeasureSelectStyles?: SelectPresentationProps;
    productQuantityBreakPricingStyles?: ProductQuantityBreakPricingStyles;
    descriptionGridItem?: GridItemProps;
    swatchGridItem?: GridItemProps;
    container?: GridContainerProps;
    descriptionStyles?: ProductDescriptionStyles;
    addToListStyles?: IconPresentationProps;
    productAddToListLinkStyles?: ProductAddToListLinkStyles;
    productDeatails?: InjectableCss;
    productBrandWrapper?: InjectableCss;
    productPartNumbersStyles?: ProductPartNumbersStyles;
    productBrandStyles?: ProductBrandStyles;
    tittleWrapper?: InjectableCss;
    PDPaddToListStyles?: InjectableCss;
}

export const productGridCardStyles: ProductListProductGridCardStyles = {
    container: {
        gap: 10,
        css: css`
            width: 100%;
        `,
    },
    productImageStyles: {
        img: {
            css: css`
                padding: 16px 14px;
                background-color: ${getColor("common.backgroundContrast")};
            `,
        },
    },
    wrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            width: 100%;
            height: 100%;
            overflow: hidden;
        `,
    },
    imageWrapper: {
        css: css`
            margin: 0 11px;
            margin: 0;
            /* background-color: ${getColor("common.backgroundContrast")}; */
            position: relative;
            [class^="StyledButton"] {
                justify-content: center;
            }
            img {
                aspect-ratio: 304/384;
                object-fit: contain;
                width: 100%;
                height: auto;
                /* mix-blend-mode: multiply; */
            }
        `,
    },
    sponsoredText: {
        css: css`
            font-size: 0.9em;
            opacity: 0.5;
            position: absolute;
            top: 12px;
        `,
    },
    swatchGridItem: {
        width: 12,
        css: css``,
    },
    descriptionGridItem: {
        width: 12,
    },

    descriptionStyles: {
        productDetailLink: {
            css: css`
                width: 100%;
                font-family: ${TYPOGRAPHY.fontFamily.title};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.mediumbold};
                font-size: ${TYPOGRAPHY.size.base};
                line-height: ${TYPOGRAPHY.lineHeight.xbase};
                color: ${getColor("text.main")};
            `,
            typographyProps: {
                size: 15,
                css: css`
                    font-family: ${TYPOGRAPHY.fontFamily.title};
                    line-height: 24px;
                    color: ${getColor("text.main")} !important;
                    ${({ theme }: { theme: BaseTheme }) =>
                        breakpointMediaQueries(theme, [
                            css`
                                padding: 0px;
                            `,
                            css`
                                padding: 0px;
                            `,
                            css`
                                padding: 0px;
                            `,
                            null,
                            null,
                        ])};
                `,
            },
        },
    },
    addToListStyles: {
        css: css`
            position: absolute;
            bottom: 2%;
            right: 3%;
            cursor: pointer;
            span {
                position: relative;
                display: inline-block;

                &::after {
                    content: "Add to Project";
                    position: absolute;
                    bottom: 125%;
                    left: 50%;
                    transform: translateX(-50%) translateX(-40px);
                    background-color: #333;
                    color: #fff;
                    text-align: center;
                    padding: 5px 10px;
                    border-radius: 4px;
                    white-space: nowrap;
                    font-size: 12px;
                    z-index: 10000;
                    opacity: 0;
                    visibility: hidden;
                    transition: opacity 0.3s;
                    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
                }

                &:hover::after {
                    visibility: visible;
                    opacity: 1;
                }

                &.hide-tooltip::after {
                    visibility: hidden !important;
                    opacity: 0 !important;
                }
            }

            /* Add media queries for specific devices */
            @media (max-width: 768px),
                (orientation: portrait) and (max-width: 1024px),
                (max-width: 1024px) and (min-width: 768px) {
                span::after {
                    display: none;
                }
            }
        `,
    },
    PDPaddToListStyles: {
        css: css`
            position: absolute;
            bottom: 2%;
            right: 3%;
            cursor: pointer;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    null,
                    null,
                    null,
                    css`
                        > span[class^="IconWrapper"] {
                            justify-content: center;
                            height: 16px !important;
                            width: 16px !important;
                            > svg {
                                height: 16px !important;
                                width: 16px !important;
                            }
                        }
                    `,
                    css`
                        > span[class^="IconWrapper"] {
                            justify-content: center;
                            height: 16px !important;
                            width: 16px !important;
                            > svg {
                                height: 16px !important;
                                width: 16px !important;
                            }
                        }
                    `,
                ])};
            span {
                position: relative;
                display: inline-block;

                &::after {
                    content: "Add to Project";
                    position: absolute;
                    bottom: 125%;
                    left: 50%;
                    transform: translateX(-50%) translateX(-40px);
                    background-color: #333;
                    color: #fff;
                    text-align: center;
                    padding: 5px 10px;
                    border-radius: 4px;
                    white-space: nowrap;
                    font-size: 12px;
                    z-index: 10000;
                    opacity: 0;
                    visibility: hidden;
                    transition: opacity 0.3s;
                    box-shadow: 0px 4px 6px rgba(0, 0, 0, 0.1);
                }

                &:hover::after {
                    visibility: visible;
                    opacity: 1;
                }

                &.hide-tooltip::after {
                    visibility: hidden !important;
                    opacity: 0 !important;
                }
            }
            @media (max-width: 768px),
                (orientation: portrait) and (max-width: 1024px),
                (max-width: 1024px) and (min-width: 768px) {
                span::after {
                    display: none;
                }
            }
        `,
    },
    productDeatails: {
        css: css`
            display: flex;
            width: 100%;
            margin-top: 12px;
            gap: 5px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        margin-top: 8px;
                        flex-direction: column;
                        padding-bottom:25px;
                    `,
                    css`
                        margin-top: 8px;
                        padding-bottom:25px;
                    `,
                    css`
                        margin-top: 8px;
                        padding-bottom:25px;
                    `,
                    null,
                    null,
                ])};
        `,
    },
    productBrandWrapper: {
        css: css`
            white-space: nowrap;
            span {
                font-family: ${TYPOGRAPHY.fontFamily.title};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.bold};
                font-size: ${TYPOGRAPHY.size.smaller};
                line-height: ${TYPOGRAPHY.lineHeight.base};
                color: ${getColor("text.main")} !important;
                > span {
                    color: ${getColor("text.main")} !important;
                }
            }
        `,
    },
    productPartNumbersStyles: {
        container: {
            css: css`
                flex-grow: 0;
                width: auto;
            `,
        },
        erpNumberLabelText: {
            css: css`
                display: none;
            `,
        },
        erpNumberValueText: {
            size: 13,
            css: css`
                font-family: ${TYPOGRAPHY.fontFamily.title};
                font-style: normal;
                font-weight: ${TYPOGRAPHY.weight.bold};
                font-size: ${TYPOGRAPHY.size.smaller};
                line-height: ${TYPOGRAPHY.lineHeight.base};
                color: ${getColor("text.main")} !important;
            `,
        },
    },
    tittleWrapper: {
        css: css`
            white-space: nowrap;
            span {
                font-weight: ${TYPOGRAPHY.weight.base};
                color: ${getColor("text.main")} !important;
            }
        `,
    },
};

const styles = productGridCardStyles;

const SurProductListProductGridCrad: FC<Props> = ({
    carouselId,
    product,
    showImage,
    showBrand,
    showTitle,
    showPartNumbers,
    showPrice,
    showAddToCart,
    showAddToList,
    updateProductInfo,
    extendedStyles,
    productInfo,
    isAuthenticated,
    pageType,
}) => {
    let variantDisplayTrait = null;

    if (!product || !productInfo) {
        return null;
    }
    if (product?.variantTraits && product.variantTraits.length > 0) {
        const swatchedViewList = [
            VariantDisplayTypeValues.SwatchDropdown,
            VariantDisplayTypeValues.SwatchList,
            VariantDisplayTypeValues.SwatchGrid,
        ];
        const sortedVaraintTraits = product.variantTraits.slice().sort((a, b) => a.sortOrder - b.sortOrder);
        variantDisplayTrait = sortedVaraintTraits.find(x => swatchedViewList.includes(x.displayType));
    }
    const productContext = {
        product,
        productInfo,
        // onUnitOfMeasureChanged: updateUnitOfMeasure,
        // onQtyOrderedChanged: updateQuantity,
    };
    return (
        <ProductContext.Provider value={productContext}>
            <StyledWrapper {...styles.wrapper} data-test-selector="productListProductCard">
                <StyledWrapper {...styles.imageWrapper}>
                    {showImage && <ProductImage product={productContext} extendedStyles={styles.productImageStyles} showSmallImage={true} />}
                    <StyledWrapper
                        {...(pageType === "ProductDetailsPage" ? styles.PDPaddToListStyles : styles.addToListStyles)}
                    >
                        <ProductAddToListLink showIcon={true} />
                    </StyledWrapper>
                </StyledWrapper>

                <StyledWrapper {...styles.productDeatails}>
                    {showBrand && product.brand && (
                        <StyledWrapper {...styles.productBrandWrapper}>
                            <ProductBrand brand={product.brand} extendedStyles={styles.productBrandStyles} />
                        </StyledWrapper>
                    )}
                    <StyledWrapper {...styles.tittleWrapper}>
                        {showTitle && (
                            <ProductDescription product={productContext} extendedStyles={styles.descriptionStyles} />
                        )}
                    </StyledWrapper>
                    {/* {showPartNumbers && (
                        <ProductPartNumbers
                            productNumber={product.productNumber}
                            customerProductNumber={product.customerProductNumber}
                            manufacturerItem={product.manufacturerItem}
                            showCustomerName={false}
                            showManufacturerItem={false}
                            extendedStyles={styles.productPartNumbersStyles}
                        />
                    )} */}
                </StyledWrapper>

                {/* {showTitle && <ProductDescription product={productContext} extendedStyles={styles.descriptionStyles} />} */}
                {/* {variantDisplayTrait && (
                    <GridItem {...styles.swatchGridItem}>
                        <ProductListVariantSwatch product={productContext} variantTrait={variantDisplayTrait} />
                    </GridItem>
                )} */}
                {/* {showPrice && isAuthenticated && (
                    <StyledWrapper>
                        <VisuallyHidden as="label" htmlFor={`${carouselId}-uom`} id={`${carouselId}-uom-label`}>
                            {translate("U/M")}
                        </VisuallyHidden>
                        <ProductPrice showLabel={false} product={productContext} />
                        {product.unitOfMeasures && (
                            <ProductUnitOfMeasureSelect
                                labelOverride=""
                                extendedStyles={styles.productUnitOfMeasureSelectStyles}
                                id={`${carouselId}-uom`}
                            />
                        )}
                        <ProductQuantityBreakPricing extendedStyles={styles.productQuantityBreakPricingStyles} />
                    </StyledWrapper>
                )} */}
            </StyledWrapper>
        </ProductContext.Provider>
    );
};

export default connect(mapStateToProps, mapDispatchToProps)(SurProductListProductGridCrad);
